exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".game-board[data-v-281e5aac]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.game-board .main[data-v-281e5aac]{display:inherit}.game-board .main .game[data-v-281e5aac]{position:relative;margin-left:15px}", ""]);

// exports
